<template>
  <ion-page>
    
    <ion-tabs>

    <iframe id="spotifyiFrame" v-bind:src="'https://open.spotify.com/embed/' + playerLink" width="100%" height="80" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>


      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="tab1" href="/music/recommended">
          <ion-icon :icon="radio" />
          <ion-label>Music</ion-label>
        </ion-tab-button>
          
        <ion-tab-button tab="tab2" href="/music/playlist">
          <ion-icon :icon="disc" />
          <ion-label>Playlist</ion-label>
        </ion-tab-button>
        
        <!--<ion-tab-button tab="tab3" href="/music/profile">
          <ion-icon :icon="person" />
          <ion-label>Profile</ion-label>
        </ion-tab-button>-->
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script lang="ts">

import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage } from '@ionic/vue';
import { ellipse, square, triangle, radio, disc,person } from 'ionicons/icons';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Tabs',
  

  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonIcon, IonPage },
  setup() {
    return {
      ellipse, 
      square, 
      triangle,
      radio,
      disc,
      person
    }
  },
  
data() {
  return {
    playerLink: `playlist/37i9dQZEVXbMDoHDwVN2tF`,
  }
},
mounted() {
    

      window.addEventListener('player-link-localstorage-changed', event => {
           if(localStorage.getItem('player-link') !== null){
             this.playerLink = localStorage.getItem('player-link') || '{}';
           }
          }, false);

//   window.addEventListener('player-link-localstorage-changed', function() {  
  
//   document.getElementById("spotifyiFrame").src= "OK";

// //   if (localStorage.getItem('player-link') !== undefined) {
// //     // continue - error suppressed when used in this way.
// //     console.log(document.getElementById('spotifyiFrame'))

// // }


//   });

 
}
})

  
</script>

<style>
*::-webkit-scrollbar {
  display: none !important;
  }
  ion-content {
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    background: #141515;

  }
</style>